module.exports = __webpack_public_path__ + "static/media/bfile-review.496fbd5e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/bfile-review.svg
// module id = 1018
// module chunks = 0